import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hero-carousel__slide hero-carousel__slide--centered"
}
const _hoisted_2 = {
  key: 0,
  class: "hero-carousel__image"
}
const _hoisted_3 = {
  autoplay: "1",
  muted: "1",
  loop: "1"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "hero-carousel__title" }
const _hoisted_6 = { class: "hero-carousel__paragraph" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "hero-carousel__title" }
const _hoisted_9 = { class: "hero-carousel__paragraph" }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 1,
  class: "hero-carousel__slide hero-carousel__slide--image-left"
}
const _hoisted_12 = {
  key: 0,
  class: "hero-carousel__image"
}
const _hoisted_13 = {
  autoplay: "1",
  muted: "1",
  loop: "1"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "hero-carousel__title" }
const _hoisted_17 = { class: "hero-carousel__paragraph" }
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 2,
  class: "hero-carousel__slide hero-carousel__slide--image-right"
}
const _hoisted_20 = { class: "hero-carousel__title" }
const _hoisted_21 = { class: "hero-carousel__paragraph" }
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  key: 0,
  class: "hero-carousel__image"
}
const _hoisted_24 = {
  autoplay: "1",
  muted: "1",
  loop: "1"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isCenteredImage($props.slide.SlideType))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          ($setup.isVideo($props.slide.MediaType))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("video", _hoisted_3, [
                  _createElementVNode("source", {
                    src: $props.slide.VideoUrl,
                    type: "video/mp4"
                  }, null, 8, _hoisted_4)
                ]),
                _createElementVNode("div", {
                  class: "hero-carousel__content",
                  style: _normalizeStyle({color: $setup.getTextColor($props.slide.BackgroundColor)})
                }, [
                  _createElementVNode("h1", _hoisted_5, _toDisplayString($props.slide.Header), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString($props.slide.Paragraph), 1),
                  ($props.slide.ButtonUrl != '' && $props.slide.ButtonLabel != '')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: $props.slide.ButtonUrl,
                        class: "btn btn-outline-secondary hero-carousel__button"
                      }, _toDisplayString($props.slide.ButtonLabel), 9, _hoisted_7))
                    : _createCommentVNode("", true)
                ], 4)
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "hero-carousel__image",
                style: _normalizeStyle({backgroundImage:`url(${$props.slide.ImageUrl})`})
              }, [
                _createElementVNode("div", {
                  class: "hero-carousel__content",
                  style: _normalizeStyle({color: $setup.getTextColor($props.slide.BackgroundColor)})
                }, [
                  _createElementVNode("h1", _hoisted_8, _toDisplayString($props.slide.Header), 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString($props.slide.Paragraph), 1),
                  ($props.slide.ButtonUrl != '' && $props.slide.ButtonLabel != '')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: $props.slide.ButtonUrl,
                        class: "btn btn-outline-secondary hero-carousel__button"
                      }, _toDisplayString($props.slide.ButtonLabel), 9, _hoisted_10))
                    : _createCommentVNode("", true)
                ], 4)
              ], 4))
        ]))
      : _createCommentVNode("", true),
    ($setup.isImageLeft($props.slide.SlideType))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          ($setup.isVideo($props.slide.MediaType))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("video", _hoisted_13, [
                  _createElementVNode("source", {
                    src: $props.slide.VideoUrl,
                    type: "video/mp4"
                  }, null, 8, _hoisted_14)
                ])
              ]))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "hero-carousel__image",
                src: $props.slide.ImageUrl
              }, null, 8, _hoisted_15)),
          _createElementVNode("div", {
            class: "hero-carousel__content",
            style: _normalizeStyle({color: $setup.getTextColor($props.slide.BackgroundColor),backgroundColor: $props.slide.BackgroundColor})
          }, [
            _createElementVNode("h1", _hoisted_16, _toDisplayString($props.slide.Header), 1),
            _createElementVNode("p", _hoisted_17, _toDisplayString($props.slide.Paragraph), 1),
            ($props.slide.ButtonUrl != '' && $props.slide.ButtonLabel != '')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: $props.slide.ButtonUrl,
                  class: "btn btn-outline-secondary hero-carousel__button"
                }, _toDisplayString($props.slide.ButtonLabel), 9, _hoisted_18))
              : _createCommentVNode("", true)
          ], 4)
        ]))
      : _createCommentVNode("", true),
    ($setup.isImageRight($props.slide.SlideType))
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", {
            class: "hero-carousel__content",
            style: _normalizeStyle({color: $setup.getTextColor($props.slide.BackgroundColor),backgroundColor: $props.slide.BackgroundColor})
          }, [
            _createElementVNode("h1", _hoisted_20, _toDisplayString($props.slide.Header), 1),
            _createElementVNode("p", _hoisted_21, _toDisplayString($props.slide.Paragraph), 1),
            ($props.slide.ButtonUrl != '' && $props.slide.ButtonLabel != '')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: $props.slide.ButtonUrl,
                  class: "btn btn-outline-secondary hero-carousel__button"
                }, _toDisplayString($props.slide.ButtonLabel), 9, _hoisted_22))
              : _createCommentVNode("", true)
          ], 4),
          ($setup.isVideo($props.slide.MediaType))
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("video", _hoisted_24, [
                  _createElementVNode("source", {
                    src: $props.slide.VideoUrl,
                    type: "video/mp4"
                  }, null, 8, _hoisted_25)
                ])
              ]))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "hero-carousel__image",
                src: $props.slide.ImageUrl
              }, null, 8, _hoisted_26))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}